import classes from './NotificationCard.module.css';
function NotificationCard(props){
        
    return <div className={classes.cardContainer}>
        <div className={classes.greenline}></div>
        <div className={classes.info}>
            <h5>{props.data.Title}</h5>
            <p className={classes.text}>{props.data.Content}</p>
        </div>
        
    </div>
}

export default NotificationCard;